/** Extrai id interno de referência FHIR (ex. `Practitioner/cpf-123` → `123`). */
export function practitionerIdFromReference(reference?: string): string | null {
  if (!reference) return null;
  const raw = reference.split("/")[1];
  if (!raw) return null;
  return raw.includes("-") ? raw.split("-").pop() ?? raw : raw;
}

/** Filtro client-side quando a API org-wide não recebe practitioner. */
export function matchesPractitionerFilter(
  practitionerFilter: string,
  authorReference?: string
): boolean {
  if (!practitionerFilter || practitionerFilter === "all") return true;
  if (!authorReference) return false;
  const id = practitionerIdFromReference(authorReference);
  if (id === practitionerFilter) return true;
  return authorReference.includes(practitionerFilter);
}
